'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {
        context.on('click', '[data-binding="membership-options-details"]', function () {
            context.find('.membership-options__membership-details').removeClass('selected');
            context.find('label.membership-select').text(context.attr('data-choose'));
            $(this).addClass('selected');
            $(this).find('[data-binding="membership-select-input-option"]').prop('checked', true);
            $(this).find('label.membership-select').text(context.attr('data-chosen'));

            if ($(window).width() <= 560) {
                var offsetTop = context.parent().find('.membership-options__button').offset().top;
                $('html, body').animate({
                    scrollTop: offsetTop
                }, 1000);
            }
        });

        context.parent('form').on('submit', function (e) {
            var form = context.parent('form');
            e.preventDefault();
            $.ajax({
                data: form.serialize(),
                type: form.attr('method'),
                url: form.attr('action')
            }).done(function (data) {
                var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);

                if (type === 'object' && data.result === 'Redirect') {
                    window.location = data.url;
                } else {
                    form.append(data);
                }
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/membership-options.js
// module id = 261
// module chunks = 0